import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import useSnackbarSystem from '@ui/systems/useSnackbarSystem';

import useAutoupdatePresenterProperty from '../../hooks/useAutoupdatePresenterProperty';
import LeaveWorkspaceTabPresenter from './LeaveWorkspaceTabPresenter';
import { getWorkspace } from '../../selectors/workspaces';
import {
	leaveWorkspace as leaveWorkspaceAction
} from '../../actions/workspaces';
import PopupSystem from '../../systems/PopupSystem';

const useLeaveWorkspaceTabPresenter = ( { workspaceID } ) => {
	const dispatch = useDispatch();
	const history = useHistory();
	// Redux State
	const workspace = useSelector(
		state => getWorkspace( state, { workspaceID } )
	);
	const snackbarSystem = useSnackbarSystem();

	const createPresenter = () => {
		// Redux Actions
		const popupSystem = new PopupSystem( dispatch );
		const leaveWorkspace = ( ...args ) => dispatch(
			leaveWorkspaceAction( ...args )
		);

		return new LeaveWorkspaceTabPresenter( {
			popupSystem,
			workspace,
			leaveWorkspace,
			showSuccessMessage: snackbarSystem.showSuccessMessage,
			showErrorMessage: snackbarSystem.showErrorMessage,
			history
		} );
	};

	const [ presenter ] = useState( createPresenter );

	useAutoupdatePresenterProperty( { presenter, name: 'workspace', value: workspace } );

	return presenter;
};

export default useLeaveWorkspaceTabPresenter;
